import { GeneralHttpResponse } from "../types/genericTypes";
import axios from "axios";
import env from "react-dotenv";

export interface QrProducto {
  id_inventario: number;
  codigo: string;
  nombre: string;
  formato: "png" | "svg";
  mime_type: string;
  imagen: string;
}

//Inventario
export const createInventarioHttp = async (data: any) => {
  try {
    const response: GeneralHttpResponse = await axios.post(
      `${env.API_URL}${"/createInventario"}`,
      data
    );
    return response?.data || [];
  } catch (error) {
    const promise = new Promise((_, reject) => reject(error));
    return promise;
  }
};
export const createInventarioOnRequiHttp = async (data: any) => {
  try {
    const response: GeneralHttpResponse = await axios.post(
      `${env.API_URL}${"/createInventarioOnRequi"}`,
      data
    );
    return response?.data || [];
  } catch (error) {
    const promise = new Promise((_, reject) => reject(error));
    return promise;
  }
};
export const asignarInventarioExistenteOnRequiHttp = async (data: any) => {
  try {
    const response: GeneralHttpResponse = await axios.post(
      `${env.API_URL}${"/asignarInventarioExistenteOnRequi"}`,
      data
    );
    return response?.data || [];
  } catch (error) {
    const promise = new Promise((_, reject) => reject(error));
    return promise;
  }
};
export const getInventarioHttp = async (search?: string) => {
  try {
    //const response = await axios.get(`${env.API_URL}/getUbicaciones`);
    const url = new URL(`${env.API_URL}/getInventario`);
    if (search) url.searchParams.append("search", search);

    const response = await axios.get(url.toString());

    return response?.data || [];
  } catch (error) {
    const promise = new Promise((_, reject) => reject(error));
    return promise;
  }
};
export const editarProductoInventarioHttp = async (data: any) => {
  try {
    const response: GeneralHttpResponse = await axios.put(
      `${env.API_URL}/editarProductoInventario`,
      data
    );
    return response?.data || [];
  } catch (error) {
    const promise = new Promise((_, reject) => reject(error));
    return promise;
  }
};
export const desactivarProductoInventarioHttp = async (data: any) => {
  try {
    const response: GeneralHttpResponse = await axios.put(
      `${env.API_URL}/desactivarProductoInventario`,
      data
    );
    return response?.data || [];
  } catch (error) {
    const promise = new Promise((_, reject) => reject(error));
    return promise;
  }
};
export const activarProductoInventarioHttp = async (data: any) => {
  try {
    const response: GeneralHttpResponse = await axios.put(
      `${env.API_URL}/activarProductoInventario`,
      data
    );
    return response?.data || [];
  } catch (error) {
    const promise = new Promise((_, reject) => reject(error));
    return promise;
  }
};
export const generarQrProductoHttp = async (data: {
  id_inventario: number;
  id_usuario: number;
  formato?: "png" | "svg";
  tamano?: number;
  con_etiqueta?: boolean;
}) => {
  try {
    const response: GeneralHttpResponse = await axios.post(
      `${env.API_URL}/generarQrProducto`,
      data
    );
    return response?.data || null;
  } catch (error) {
    const promise = new Promise((_, reject) => reject(error));
    return promise;
  }
};
export const generarQrProductosHttp = async (datos: {
  ids_inventario: number[];
  id_usuario: number;
}) => {
  try {
    const response = await axios.post(`${env.API_URL}/generarQrProductos`, datos);
    return response?.data;
  } catch (error) {
    return Promise.reject(error);
  }
};